export default __webpack_public_path__ + "static/media/shared-earth-icons-12.b388fbeb.svg";